import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import HomeIcon from "@redotech/redo-icons/home-02.svg";
import HomeFilledIcon from "@redotech/redo-icons/home-02_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { LinkPrimaryTab } from "@redotech/redo-web/arbiter-components/navigation/primary/redo-primary-nav";
import { PageNavigationEntry } from "@redotech/redo-web/arbiter-components/navigation/redo-side-navigation";

export function useHomeNavigation(): PageNavigationEntry | null {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);

  const primaryTab: LinkPrimaryTab = {
    id: "home",
    hasNotification: false,
    UnfilledIcon: HomeIcon,
    FilledIcon: HomeFilledIcon,
    type: "link",
    href: routes.homeBaseHref,
    pathRoot: routes.homeBaseHref,
    friendlyName: t("Home"),
  };

  // Home is an icon-only tab with no secondary panel.
  return {
    primaryTab,
    secondaryNavigationData: undefined,
    isCore: true,
    pinFirst: true,
  };
}
